function getCookie(name) {
  const value = '; ' + document.cookie;
  const parts = value.split('; ' + name + '=');
  if (parts.length === 2) return parts.pop().split(';').shift();
}

const AVAILABLE_LOCALES = ['de-DE', 'en-GB', 'es-ES', 'fr-FR', 'nl-BE'];
const DEFAULT_LANG = 'fr-FR';
const COOKIE_RESOLVER_NAME = 'org.springframework.web.servlet.i18n.CookieLocaleResolver.LOCALE';

const browserLocale = AVAILABLE_LOCALES.find((l) => l === navigator.language || l.includes(navigator.language));

const userLanguage = getCookie(COOKIE_RESOLVER_NAME) || browserLocale || DEFAULT_LANG;

document.documentElement.lang = userLanguage;
